import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { history } from "src/navigation/store";
import { makeHierarchicalPath } from "./Link";
import { FeScheme } from "src/types/navigation";

export const useRedirect = () => {
  const navigate = useNavigate();

  const redirect = useCallback((schemes: FeScheme, state?: Record<string, unknown>) => {
    const to = makeHierarchicalPath(
      history.location,
      Array.isArray(schemes) ? schemes : [schemes],
      "replace"
    );

    if (to) {
      navigate(to, { replace: true, state: { ...state, from: history.location.pathname } });
    }
  }, [navigate]);

  return { redirect };
};